export default "__VITE_ASSET__923a0de8__"